// extracted by mini-css-extract-plugin
export default {"chartContainer":"ProfitChartComponent_chartContainer__dOAEZ","borderContainer":"ProfitChartComponent_borderContainer__rVdBA","chartBtns":"ProfitChartComponent_chartBtns__gZ8uY"};